import * as React from "react"
import {Navigate} from "react-router-dom";

import {BANNERS_ROUTES} from "@constants"
import AppLayout from "Layout"
import BannersPercentagePage from "./Percentage";
import TopBannersPage from "./TopBanners"
import BannersDetailsPage from "./BannersDetails"
import BannersViewScreenshotPage from "./ViewScreenshot";


export const BannersRoutes = {
    path: BANNERS_ROUTES.PATH,
    title: BANNERS_ROUTES.TITLE,
    accessKey: BANNERS_ROUTES.ACCESS_KEY,
    icon: 'window',
    description: "Tracking of banners & other visibility elements",
    element: <AppLayout />,
    children: [{
        element: <Navigate to={BANNERS_ROUTES.TOP_BANNERS_PATH} replace />,  index: true
    }, {
        id: BANNERS_ROUTES.PERCENTAGE_ID,
        path: BANNERS_ROUTES.PERCENTAGE_URL,
        dashboardKey: BANNERS_ROUTES.PERCENTAGE_ID,
        title: BANNERS_ROUTES.PERCENTAGE_TITLE,
        element: <BannersPercentagePage />
    }, {
        title: 'Top Banners',
        path: BANNERS_ROUTES.TOP_BANNERS_PATH,
        dashboardKey: BANNERS_ROUTES.TOP_BANNERS_ID,
        element: <TopBannersPage />
    }, {
        title: 'Banners Details',
        path: BANNERS_ROUTES.BANNERS_DETAILS_PATH,
        dashboardKey: BANNERS_ROUTES.BANNERS_DETAILS_ID,
        element: <BannersDetailsPage />
    }, {
        id: BANNERS_ROUTES.VIEW_SCREENSHOT_ID,
        path: BANNERS_ROUTES.VIEW_SCREENSHOT_URL,
        dashboardKey: BANNERS_ROUTES.VIEW_SCREENSHOT_ID,
        notRender: true,
        element: <BannersViewScreenshotPage />
    }]
}